import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;
//get all users
function getAllUsers(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/admin/users/?active_only=True/`,
    oauthTokenHeader,
  );
}
//post comment
function postComment(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any,
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

//fetch comments
function getComments(
  oauthTokenHeader: string,
  object_type: string,
  object_shared_uid: any,
  last_time?: any,
) {
  const objectSharedUids =
    Array.isArray(object_shared_uid) &&
    object_shared_uid.map((uid: any) => `object_shared_uid=${uid}`).join("&");
  const lastTimeParam = last_time ? `&last_time=${last_time}` : "";
  return fetchWrapper.get(
    `${apiUrl}/utilities/comments/?object_type=${object_type}&${objectSharedUids}${lastTimeParam}`,
    oauthTokenHeader,
  );
}

//fetch comments via POST (for large payloads)
function getCommentsPost(
  oauthTokenHeader: string,
  object_type: string,
  object_shared_uid: any,
  last_time?: any,
) {
  const body: Record<string, any> = {
    object_type,
    object_shared_uid: Array.isArray(object_shared_uid)
      ? object_shared_uid
      : [object_shared_uid],
  };
  if (last_time) body.last_time = last_time;
  return fetchWrapper.post(
    `${apiUrl}/utilities/get_comments/`,
    body,
    oauthTokenHeader,
  );
}

//update comment
function putComments(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any,
) {
  return fetchWrapper.put(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

//delete comment
function deleteComment(
  oauthTokenHeader: string,
  object_shared_uid: any,
  comment_shared_uid: any,
) {
  return fetchWrapper.delete(
    `${apiUrl}/utilities/comments/${object_shared_uid}/?comment=${comment_shared_uid}`,
    oauthTokenHeader,
  );
}
//fetch files
function getFiles(
  oauthTokenHeader: string,
  object_type: string,
  object_shared_uid: any,
) {
  const objectSharedUids =
    Array.isArray(object_shared_uid) &&
    object_shared_uid.map((uid: any) => `object_shared_uid=${uid}`).join("&");

  return fetchWrapper.get(
    `${apiUrl}/utilities/file/?object_type=${object_type}&${objectSharedUids}`,
    oauthTokenHeader,
  );
}

//fetch files via POST (for large payloads)
function getFilesPost(
  oauthTokenHeader: string,
  object_type: string,
  object_shared_uid: any,
) {
  const body = {
    object_type,
    object_shared_uid: Array.isArray(object_shared_uid)
      ? object_shared_uid
      : [object_shared_uid],
  };
  return fetchWrapper.post(
    `${apiUrl}/utilities/get_files/`,
    body,
    oauthTokenHeader,
  );
}
//upload file
function uploadFile(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any,
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    data,
    oauthTokenHeader,
  );
}

//delete file
function deleteFile(oauthTokenHeader: string, file_shared_uid: any) {
  return fetchWrapper.delete(
    `${apiUrl}/utilities/file/${file_shared_uid}/`,
    oauthTokenHeader,
  );
}

export const discussionCommentsFilesService = {
  postComment,
  getComments,
  getCommentsPost,
  putComments,
  getFiles,
  getFilesPost,
  uploadFile,
  getAllUsers,
  deleteComment,
  deleteFile,
};
